import React, { useEffect } from 'react';
import { BrowserRouter, BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AdhesionLink } from './FormAdhesion/pages/AdhesionClientesLink';
import { TutorialAdhesion } from './FormAdhesion/pages/TutorialAdhesionApp';
import { Layout } from './shared/Layouts/Layout';
import { AnalyticsRoot } from './components/AnalyticsRoot';

export const App: React.FC = () => {
  

  return (
  
    <BrowserRouter basename={process.env.PUBLIC_URL}>
    <AnalyticsRoot />
    <Layout>
      <Routes>
        <Route path="/" element={<AdhesionLink/>} />
        <Route path="/TutorialAdhesionApp" element={<TutorialAdhesion/>} />
      </Routes>
    </Layout>
  </BrowserRouter>
  );
};
